/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_Header_Footer_HintInputs */

const en_reading_class_header_footer_hint = /** @type {(inputs: Reading_Class_Header_Footer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeated at the top or bottom`)
};

const es_reading_class_header_footer_hint = /** @type {(inputs: Reading_Class_Header_Footer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se repite arriba o abajo`)
};

/**
* | output |
* | --- |
* | "Repeated at the top or bottom" |
*
* @param {Reading_Class_Header_Footer_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_header_footer_hint = /** @type {((inputs?: Reading_Class_Header_Footer_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_Header_Footer_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_header_footer_hint(inputs)
	return en_reading_class_header_footer_hint(inputs)
});